import ModalsLib from '../../../../lib/modals';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/daily/games';
import Diamond from '../diamond';
import {navigate} from '../../../../utils/navigation';

export default () => {
    const {task} = useSelector(Selector);

    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/games.png`} alt="Games Icon" />
                </div>
                <div className="title">Game Explorer</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Play in three separate games daily to receive diamond prizes.
                </div>
                {(task.completed || task.redeemed) ? (
                    <div className="button-block completed">
                        Completed
                    </div>
                ) : (
                    <div className="button-block">
                        <div className="button" onClick={e => {
                            navigate('/');
                        }}>
                            Play
                        </div>
                        <div className="diamonds">
                            <Diamond />
                            {task.reward}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}